/**
 * Monitors focus events on the Chat Interface's text areas, and
 * ensures that the chat stays in view and usaable on mobile-phone browsers.
 *
 *   - "mobile" == Capabilities.isMobile()
 *   - Because we're on "mobile" browsers, we don't support IE
 *   - Because we're on "mobile" browsers, we don't consider persistent chat.
 */
/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitor
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor = function() {};
$hxClasses.registerClass(com.inq.flash.client.chatskins.ChatTextFocusMonitor, "com.inq.flash.client.chatskins.ChatTextFocusMonitor");

/** @private @type {ChatTextFocusMonitorImplBase} */ com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = null;


/** @private @type {boolean} */
com.inq.flash.client.chatskins.ChatTextFocusMonitor._isCriOS8 = (/(iPhone|iPod|iPad).*(CPU\s(iPhone|iPod|iPad)\sOS\s(6|7|8|9)_).*AppleWebKit?.*CriOS/i.test(navigator.userAgent));
/* NOTE: About the above
 * We check for version 8 of safari instead of ios8 because:
 *	1) we are interested in the safari browser
 *	2) the mac ios8 emulator shows the operating system as the osx os, so we must look at the browser version
 */

/**
 * init - Initializes ChatTextFocusMonitor.  DOES NOTHING if the
 * user agent is NOT a 'mobile' browser, OR if the user agent
 * doesn't automatically zoom in to text fields.  So this doesn't
 * have to work in IE, Firefox, et al.
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function init():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.init = function() {
    com.inq.flash.client.chatskins.ChatTextFocusMonitor.closing = false;
    com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().init(); // Initialize impl, if it hasn't happened already.
};


/**
 * Retrieves the correct subclass of ChatTextFocusMonitorImplBase.
 *
 * @private
 * @return {ChatTextFocusMonitorImplBase}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl = function () {
	if (!!com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl) {
		return com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl;
	} else {
		var agent = com.inq.utils.Capabilities.getUserAgent();

		if (com.inq.utils.Capabilities.isChromeOnIphone()) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10();
		} else if (com.inq.utils.Capabilities.isSafariVersion10()) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari10();
		} else if (com.inq.utils.Capabilities.isSafariVersion14orLater()) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13();
		} else if (com.inq.utils.Capabilities.isSafariVersion13()) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13();
		} else if (com.inq.utils.Capabilities.isSafariVersion12()) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari12();
		} else if (com.inq.utils.Capabilities.isSafariVersion11()) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari11();
		} else if (com.inq.utils.Capabilities.isSafariVersion9()) { /* test for uiWebKit  - the iOS vodafone app */
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari9();
		} else if (com.inq.utils.Capabilities.isSafariVersionPrior8()) { /* test for uiWebKit  - the iOS vodafone app */
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7();
		} else if (com.inq.utils.Capabilities.isSafariVersion8()) { /* test for uiWebKit  - the iOS vodafone app */
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8();
		} else if (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(agent)) { /* test for uiWebKit  - the iOS vodafone app */
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplVodafoneAppIos();
		} else if (com.inq.utils.Capabilities.isChromeiOS8()) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplCRiOS8();
		} else if (com.inq.utils.Capabilities.isWindowsPhone()) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone();
		} else if (/(iPhone|iPod|iPad).*AppleWebKit?.*CriOS/i.test(agent)) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneChrome();
		} else if (/(iPhone|iPod|iPad).*AppleWebKit(?!.*CriOS).*Safari/i.test(agent)) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari();
		} else if (/android/i.test(agent)) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplAndroid();
		} else {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl = new com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase();
		}

		return com.inq.flash.client.chatskins.ChatTextFocusMonitor.impl;
	}
};



/**
 * Close
 * Remove event handlers attached to textArea..
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function Close():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.Close = function() {
    com.inq.flash.client.chatskins.ChatTextFocusMonitor.closing = true;
    com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().Close();
};

/**
 * blur
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function blur()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.blur = function() {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().blur();
    }
};


/**
 * HasFocus
 *
 * $type TFun([],TEnum(Bool,[]))
 * static public function HasFocus():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.HasFocus = function() {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().HasFocus();
    }
};


/**
 * setHasFocus
 *
 * $type TFun([],TEnum(Bool,[]))
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.setHasFocus = function() {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().setHasFocus();
    }
};

/**
 * return the input element which currently has focus
 * @static
 * @public
 * @return HTMLInputElement
 */

com.inq.flash.client.chatskins.ChatTextFocusMonitor.getFocusElement = function() {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().getFocusElement();
    }
};

/**
 * blurFocusedElement - blur focused element
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.blurFocusedElement = function() {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().blurFocusedElement();
    }
};
/**
 * scrollToPrevious
 * Scroll to the previous position
 * Call this only after saveWindowPosition has been called
 * *
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function scrollToPrevious():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.scrollToPrevious = function() {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().scrollToPrevious();
    }
};


/**
 * saveWindowPositionForce
 * Helper function for restoreWindowPosition. Refactored in RTDEV-3840 because there is
 * a conditional in saveWindowPosition that only detects if things are not minimized.
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function saveWindowPositionForce():Void
 * @public
 * @static
 * @see restoreWindowPosition
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.saveWindowPositionForce = function() {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().saveWindowPositionForce();
    }
};


/**
 * saveWindowPosition
 * Save the current window and chat interface posisitions.
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function saveWindowPosition():Void
 * @public
 * @static
 * @see restoreWindowPosition
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.saveWindowPosition = function() {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().saveWindowPosition();
    }
};

/**
 * clearWindowPosition
 * Clear the current window and chat interface posisitions.
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function saveWindowPosition():Void
 * @public
 * @static
 * @see restoreWindowPosition
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.clearWindowPosition = function() {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().clearWindowPosition();
    }
};

/**
 * hasSavedWindowPosition
 * Do we have a saved window position?
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function saveWindowPosition():Void
 * @public
 * @static
 * @see restoreWindowPosition
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.hasSavedWindowPosition = function() {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().hasSavedWindowPosition();
    }
};

/**
 * restoreWindowPosition
 * Restore the saved window and chat interface posisitions.
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function restoreWindowPosition():Void
 * @public
 * @static
 * @see saveWindowPosition
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.restoreWindowPosition = function() {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().restoreWindowPosition();
    }
};

/**
 * FixIPhoneFocusScroll
 * Fix the positioning of an element after focus messes it up :)
 *
 * @public
 * @see ScrollMonitor.whenPhoneScroll
 * @static
 * @return {boolean} true if correction is needed
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.FixIPhoneFocusScroll = function() {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().FixIPhoneFocusScroll();
    }
};


/**
 * onFocus - Handler for focus events on the chat interface's text
 * input area.
 *
 * This includes a hack to get around a quirk of iOS.
 *
 *
 * THE QUIRK:
 *
 * Safari on iOS does NOT take the on-screen keyboard
 * into account when reporting values for
 * window.innerWidth/Height.
 *
 * THE WORK-AROUND:
 *
 * If we scroll the page all the way to the bottom, the bottom of
 * the visible area will line up with the top of the on-screen
 * keyboard.  In this state, window.innerWidth/Height reflects the
 * actual visible portion of the page, which is now exactly small
 * enough to fit above the on-screen keyboard.
 *
 * IN A NUTSHELL:
 *
 * By scrolling the page all the way to the bottom, we force iOS
 * to correctly report the size of the current viewport above the
 * keyboard.
 *
 * $type TFun([],TEnum(Bool,[]))
 * static public function onFocus():Bool
 * @public
 * @static
 * @this {HTMLElement} ev.target
 * @param {FocusEvent}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus = function(ev) {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().onFocus(ev, this);
    }
};

/**
 * expandChat - is used to resize the chat interface and display the chat in full screen mode.
 * The current implementation is supported for iPhone only.
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.expandChat = function() {
	if (!com.inq.ui.Stage.getInstance().getVisible() || com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
		return false;
	}

	return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().expandChat();
};

/**
 * shrinkChat - is used to resize the chat interface when software keyboard is displayed.
 * The current implementation is supported for iPhone only.
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.shrinkChat = function() {
	if (!com.inq.ui.Stage.getInstance().getVisible() || com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
		return false;
	}

	return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().shrinkChat();
};

/**
 * onTouchStart - Listener for the touchstart event
 * input area.
 *
 * Since we are serving impls and the impl will always be the same for the life of the chat,
 *  we can then treat the impls as singletons and process the event from a static
 *  The static ...
 *
 * @public
 * @static
 * @this {HTMLElement} ev.target
 * @param {Event}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchStart = function(ev) {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().onTouchStart(ev, this);
    }
};


/**
 * onMouseDown - Listener for the mousedown event
 * input area.
 *
 * Since we are serving impls and the impl will always be the same for the life of the chat,
 *  we can then treat the impls as singletons and process the event from a static
 *  The static ...
 *
 * @public
 * @static
 * @this {HTMLElement} ev.target
 * @param {Event}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.onMouseDown = function(ev) {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().onMouseDown(ev, this);
    }
};

/**
 * onTouchMove - Listener for the touchmove event
 * input area.
 *
 * Since we are serving impls and the impl will always be the same for the life of the chat,
 *  we can then treat the impls as singletons and process the event from a static
 *  The static ...
 *
 * @public
 * @static
 * @this {HTMLElement} ev.target
 * @param {Event}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchMove = function(ev) {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().onTouchMove(ev, this);
    }
};

/**
 * onTouchEnd - Listener for the touchend event
 * input area.
 *
 * Since we are serving impls and the impl will always be the same for the life of the chat,
 *  we can then treat the impls as singletons and process the event from a static
 *  The static ...
 *
 * @public
 * @static
 * @this {HTMLElement} ev.target
 * @param {Event}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchEnd = function(ev) {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().onTouchEnd(ev, this);
    }
};

/**
 * resizeToViewportIphone
 * Resize the chat so that it fills the viewport.
 *
 * This is what we want to do:
 *	 1) disable the scroll monitor, it messes us up for our sizing of the viewport
 *	 2) If we have focus and on iphone or ipad, we want to
 *		2a) scroll to the bottom, this requires us to:
 *			* change the clients body style to allow us to scroll down, we change the minHeight and minWidth
 *			* to set listener for scroll the scroll down.
 *			* At completion of scroll down, get viewport and restore body minHeight and minWidth
 *			* Reenable scroll monitor
 *	3) No focus,
 *		get viewport size
 *		reenable scroll monitor
 *
 * We will get the size of the keyboard and use it for later, we do NOT have to keep going to the bottom of the page to calculate the screen size
 * We will keep a keyboard height for portrait and for landscape modes.
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function resizeToViewport():Void
 * @public
 * @static
 * @param {string}  from
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.resizeToViewportIphone = function(from) {
    com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().resizeToViewportIphone();
};


/**
 * resizeToViewportLegacy
 * Resize the chat so that it fills the viewport.
 *
 * This is what we want to do:
 *	 1) disable the scroll monitor, it messes us up for our sizing of the viewport
 *	 2) If we have focus and on iphone or ipad, we want to
 *		2a) scroll to the bottom, this requires us to:
 *			* change the clients body style to allow us to scroll down, we change the minHeight and minWidth
 *			* to set listener for scroll the scroll down.
 *			* At completion of scroll down, get viewport and restore body minHeight and minWidth
 *			* Reenable scroll monitor
 *	3) No focus,
 *		get viewport size
 *		reenable scroll monitor
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function resizeToViewport():Void
 * @public
 * @static
 * @param {string}  from
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.resizeToViewportLegacy = function(from) {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().resizeToViewportLegacy(from);
    }
};


/**
 * resizeToViewport
 * Resize the chat so that it fills the viewport.
 *
 * To test for uiWebView (iphone/ipad webbrowser package) we do the following
 *		var uiWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
 * The uiWebView is used by:  Chrome for ipad/iphone, Vodafone app, Voyage Prive app, Dolphin and others
 * So we want to use the legacy app if iPhone and uiWebView
 *
 * @public
 * @static
 * @param {string}  from
 * @return {void}
 */

com.inq.flash.client.chatskins.ChatTextFocusMonitor.resizeToViewport = function(from) {
	com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().resizeToViewport(from);
};


/**
 * getKeyboardHeight
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.getKeyboardHeight = function() {
	return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().getKeyboardHeight();
};

/**
 * setKeyboardHeight
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.setKeyboardHeight = function(keyboardHeight) {
    com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().setKeyboardHeight(keyboardHeight);
};

/**
 * onOrientationChange
 * Respond to orientation changes.
 *
 * $type TFun([{ name => ev, t => TType(js.Event,[]), opt => false }],TEnum(Bool,[]))
 * static public function onOrientationChange(ev:Event):Bool
 * @public
 * @static
 * @this {Window} ev.target
 * @param {js.Event}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.onOrientationChange = function(ev) {
    return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().onOrientationChange(ev, this);
};

/**
 * com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlurHandlerPhoneIphone
 *   For iPhone only, Restore the original scroll position & chat dimensions.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlurHandlerPhoneIphone = function() {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().onBlurHandlerPhoneIphone();
    }
};

/**
 * onPaste - Strip trailing newlines from text pasted into the text input.
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => true }],TEnum(Bool,[]))
 * static public function onPaste(?me:MouseEvent):Bool
 * @public
 * @static
 * @this {HTMLElement} ev.target
 * @param {com.inq.events.Event}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.onPaste = function(ev) {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().onPaste(ev, this);
    }
};

/**
 * Allows client code to determine whether a blur handler is pending.
 *
 * @return {Boolean} Is there a pending handler?
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.isBlurHandlerPending = function() {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().isBlurHandlerPending();
    }
};

/**
 * Cancels a pending blur handler.  It's necessary to encapsulate this
 * so that client code need not be aware of whether we've used
 * window.setTimeout or Capabilities.setDomSafeTimeout to create the
 * delay.
 *
 * @return {Void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.cancelBlurHandler = function() {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().cancelBlurHandler();
    }
};

/**
 * onBlur - Restore the original scroll position & chat dimensions.
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => true }],TEnum(Bool,[]))
 * static public function onBlur(?me:MouseEvent):Bool
 * @public
 * @static
 * @this {HTMLElement} ev.target
 * @param {FocusEvent}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur = function(ev) {
    if (com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        return false;
    } else {
        return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().onBlur(ev, this);
    }
};


/**
 * Tells us whether we're running on iOS 6. Putting
 * this here as an emergency fix.  FIXME: Move this into Capabilities
 * ASAP.
 *
 * @return {string} system version
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.isIos6 = function() {
    return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().isIos6();
};

/**
 * onScrollCallback - callback for the scroll monitor for specific action per implementation
 *
 * @see com.inq.flash.client.chatskins.ScrollMonitor.whenPhoneScroll
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.onScrollCallback = function(){
	try {
        if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
            com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().onScrollCallback();
        }
	}catch (err) {
		haxe.Log.trace("Error: " + err, { fileName : "ChatTextFocusMonitor.js", lineNumber : 167, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "onScrollCallback"});
	}
};

/**
 * calculateViewableArea - calculates the actual viewable area after considering the keyboard height per implementation
 *
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.calculateViewableArea = function () {
	try {
		if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
			return com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().calculateViewableArea();
		}
	} catch (err) {
		haxe.Log.trace("Error: " + err, {
			fileName: "ChatTextFocusMonitor.js",
			lineNumber: 695,
			className: "com.inq.flash.client.chatskins.ChatTextFocusMonitor",
			methodName: "calculateViewableArea"
		});
	}
};

/**
 * isVersion8 - true if version 8 of safari, false if not
 * @public
 * @deprecated please use the corresponding method in capabilities
 * @returns {boolean} true if version 8 of Safari
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.isVersion8 = function() {
    return com.inq.utils.Capabilities.isSafariVersion8();
};

/**
 *	isVersionPrior8 - true if version 8 of safari, false if not
 *  @deprecated please use the corresponding method in capabilities
 *	@returns {boolean} true if version 8 of Safari
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.isVersionPrior8 = function() {
    return com.inq.utils.Capabilities.isSafariVersionPrior8();
};

/**
 *	isCriOS8 - true if Chrome on iOS 8, false if not
 *  @deprecated please use the corresponding method in capabilities
 *	@returns {boolean} true if Chrome on iOS 8
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.isCriOS8 = function() {
    return  com.inq.utils.Capabilities.isChromeiOS8();
};

/** @public @const @type {number} */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.SAFARI_KEYBOARD_HEIGHT_PORTRAIT = 260;
/** @public @const @type {number} */
com.inq.flash.client.chatskins.ChatTextFocusMonitor.SAFARI_KEYBOARD_HEIGHT_LANDSCAPE = 162;
